/* Moyoni motion controller.
   One small module: tags elements for scroll reveal, runs the header/parallax scroll loop,
   animates accordions and the add-to-cart confirmation. No dependencies.
   Does nothing unless <html> carries .mo-js (see layout/theme.liquid). */
(function () {
  'use strict';
  var root = document.documentElement;
  var on = root.classList.contains('mo-js');
  var designMode = !!(window.Shopify && Shopify.designMode);
  var small = window.matchMedia('(max-width: 749px)');
  var io = null;

  /* ---- what gets revealed, and how it is grouped ---- */
  var GROUPS = [
    '.shopify-section:not(:first-child) .title-wrapper-with-link',
    '.moyoni-split__row .moyoni-tile',
    '.moyoni-hero:not(:first-child) .moyoni-hero__copy > *',
    '.shopify-section:not(:first-child) .card-wrapper',
    '.moyoni-rvs .moyoni-label, .moyoni-rvs__title, .moyoni-rvs__sum',
    '.moyoni-rvs__grid .moyoni-rv, .moyoni-rvs__more, .moyoni-rvs__note',
    '.moyoni-trust > div',
    '.footer .footer-block, .footer__content-bottom',
    '.moyoni-seo, .collection-hero, .moyoni-collection-hero > *'
  ].join(',');

  function tag(scope) {
    if (!on || root.getAttribute('data-mo-reveal') !== 'true') return;
    var nodes = (scope || document).querySelectorAll(GROUPS);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.hasAttribute('data-mo')) continue;
      // anything already inside the first screen of the first section is left alone (hero is CSS-driven)
      if (el.closest('#MainContent > .shopify-section:first-child')) continue;
      if (el.closest('.moyoni-rvs__dup')) continue;
      el.setAttribute('data-mo', '');
      if (!io) io = new IntersectionObserver(onIntersect, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      // a clipped element reports zero intersection, so tiles are watched through their row
      var target = el.classList.contains('moyoni-tile') ? el.parentElement : el;
      if (target !== el) { (target.__moKids = target.__moKids || []).push(el); }
      io.observe(target);
    }
  }

  function onIntersect(entries) {
    var batch = 0;
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var host = e.target;
      var step = small.matches ? 55 : 90;
      var list = host.__moKids || [host];
      list.forEach(function (el) {
        el.style.setProperty('--mo-d', Math.min(batch, 6) * step + 'ms');
        batch++;
        el.classList.add('mo-in');
      });
      host.__moKids = null;
      io.unobserve(host);
    });
  }

  /* ---- header state + gentle hero drift (one rAF-throttled scroll loop) ---- */
  var ticking = false, scrolled = false, heroes = [];
  function collectHeroes() {
    heroes = [].slice.call(document.querySelectorAll('.moyoni-hero__img'));
  }
  function frame() {
    ticking = false;
    var y = window.pageYOffset || 0;
    var s = y > 24;
    if (s !== scrolled) { scrolled = s; root.classList.toggle('mo-scrolled', s); }
    if (root.getAttribute('data-mo-hero') === 'true' && !small.matches) {
      var vh = window.innerHeight;
      for (var i = 0; i < heroes.length; i++) {
        var host = heroes[i].parentElement.closest('.moyoni-hero');
        if (!host) continue;
        var r = host.getBoundingClientRect();
        if (r.bottom < -50 || r.top > vh + 50) continue;
        // progress -1..1 around the viewport centre; max drift 2% of hero height
        var p = ((r.top + r.height / 2) - vh / 2) / (vh / 2 + r.height / 2);
        heroes[i].style.setProperty('--mo-py', (-p * r.height * 0.02).toFixed(1) + 'px');
      }
    }
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

  /* ---- accordions: animate height with WAAPI ---- */
  function initAccordions() {
    document.addEventListener('click', function (ev) {
      if (!on) return;
      var sum = ev.target.closest && ev.target.closest('.accordion > details > summary, details.moyoni-acc > summary');
      if (!sum) return;
      var det = sum.parentElement;
      if (det.__moBusy) { ev.preventDefault(); return; }
      ev.preventDefault();
      det.__moBusy = true;
      var start = det.offsetHeight, end, wasOpen = det.open;
      if (!det.open) {
        det.open = true;
        end = det.offsetHeight;
      } else {
        det.open = false;
        end = det.offsetHeight;
        det.open = true;
      }
      det.classList.add('mo-animating');
      var anim = det.animate([{ height: start + 'px' }, { height: end + 'px' }], { duration: 380, easing: 'cubic-bezier(.22,.61,.36,1)' });
      var closing = wasOpen;
      anim.onfinish = anim.oncancel = function () {
        if (closing) det.open = false;
        det.classList.remove('mo-animating');
        det.__moBusy = false;
      };
      // never leave a panel half-animated (background tab, slow device)
      setTimeout(function () { if (det.__moBusy) anim.finish(); }, 700);
    });
  }

  /* ---- add to cart confirmation ---- */
  function initAddFeedback() {
    if (!window.fetch || window.__moFetch) return;
    window.__moFetch = true;
    var orig = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = orig.apply(this, arguments);
      if (on && /\/cart\/add/.test(url)) {
        p.then(function (res) { if (res && res.ok) confirmAdded(); }).catch(function () {});
      }
      return p;
    };
  }
  function confirmAdded() {
    setTimeout(function () {
      var btns = document.querySelectorAll('.product-form__submit, .moyoni-sticky__btn');
      btns.forEach(function (b) {
        if (!b.offsetParent) return;
        var label = b.querySelector('span:not(.loading__spinner)') || b;
        if (b.__moT) return;
        var prev = label.textContent;
        label.textContent = 'Added';
        b.classList.add('mo-added');
        b.__moT = setTimeout(function () {
          label.textContent = prev;
          b.classList.remove('mo-added');
          b.__moT = null;
        }, 1600);
      });
    }, 140);
  }

  /* ---- product gallery (slider layouts): mark the slide in view ---- */
  function initGallery(scope) {
    (scope || document).querySelectorAll('slider-component .slider').forEach(function (sl) {
      if (sl.__moG) return;
      sl.__moG = true;
      var slides = sl.querySelectorAll('.product__media-item');
      if (!slides.length) return;
      var gio = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('mo-current', e.isIntersecting && e.intersectionRatio > 0.6); });
      }, { root: sl, threshold: [0.6] });
      slides.forEach(function (s) { gio.observe(s); });
    });
  }

  /* ---- reviews marquee play/pause ---- */
  function initReviews(scope) {
    (scope || document).querySelectorAll('.moyoni-rvs__ctl').forEach(function (btn) {
      if (btn.__moR) return;
      btn.__moR = true;
      btn.addEventListener('click', function () {
        var sec = btn.closest('.moyoni-rvs');
        var paused = sec.classList.toggle('is-paused');
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        btn.querySelector('span').textContent = paused ? 'Play' : 'Pause';
      });
    });
  }

  function init(scope) {
    tag(scope);
    initGallery(scope);
    initReviews(scope);
    collectHeroes();
    onScroll();
  }

  function boot() {
    init();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    initAccordions();
    initAddFeedback();
    // content swapped in by filters / sorting / predictive search / cart: tag new nodes
    if (on && window.MutationObserver) {
      var pend = false;
      new MutationObserver(function () {
        if (pend) return; pend = true;
        requestAnimationFrame(function () { pend = false; tag(); initGallery(); }); 
      }).observe(document.body, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    document.addEventListener('shopify:section:unload', collectHeroes);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
